import React, { useRef, useEffect, useState } from "react";
import styles from "./WebcamCapture.module.css";

export function WebcamCapture({ onCollapse, onPhoto }) {
  const videoRef = useRef(null);
  const photoRef = useRef(null);
  const [hasPhoto, setHasPhoto] = useState(false);

  const getVideo = () => {
    navigator.mediaDevices
      .getUserMedia({
        video: { width: { ideal: 358 }, height: { ideal: 294 } },
      })
      .then((stream) => {
        let video = videoRef.current;
        video.srcObject = stream;
        video.play();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const muteVideoTrack = () => {
    videoRef.current.srcObject
      .getVideoTracks()
      .forEach((track) => track.stop());
  };

  const takePhoto = () => {
    const width = 352;
    const height = 288;

    let video = videoRef.current;
    let photo = photoRef.current;

    photo.width = width;
    photo.height = height;
    let ctx = photo.getContext("2d");
    ctx.drawImage(video, 0, 0, width, height);
    setHasPhoto(true);
  };

  const clear = () => {
    let photo = photoRef.current;
    let ctx = photo.getContext("2d");

    ctx.clearRect(0, 0, photo.width, photo.height);
    setHasPhoto(false);
  };

  const handleSave = () => {
    photoRef.current.toBlob((blob) => onPhoto(blob), "image/jpeg", 1);
    muteVideoTrack();
  };

  useEffect(() => {
    getVideo();
  }, [videoRef]);

  return (
    <div className={styles.container}>
      <div className={styles.camera}>
        <video ref={videoRef}></video>
        <canvas
          ref={photoRef}
          className={`${hasPhoto ? styles.hasPhoto : ""}`}
        ></canvas>
        <div
          className={`${
            hasPhoto ? styles.photoOverlay : styles.noPhotoOverlay
          }`}
        ></div>
        {hasPhoto ? (
          <>
            <button className={styles.takePhoto} onClick={handleSave}>
              Confirm
            </button>
            <button className={styles.cancel} onClick={clear}>
              Redo?
            </button>
          </>
        ) : (
          <>
            <button className={styles.takePhoto} onClick={takePhoto}>
              Take Photo
            </button>
            <button
              className={styles.cancel}
              onClick={() => {
                onCollapse();
                muteVideoTrack();
              }}
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </div>
  );
}
